import { Element } from "@/components/elements/UIElement";
import { ElementsQueryData } from "./elementsQuery";

type RawElement = Omit<Element, "config"> & {
  config: unknown;
};

type RawElementsResponse = {
  elements?: RawElement[];
  requests?: ElementsQueryData["requests"];
  elementsVersion?: number;
};

const parseElementConfig = (value: unknown): Record<string, unknown> => {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return value as Record<string, unknown>;
  }

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        return parsed as Record<string, unknown>;
      }
    } catch {
      return {};
    }
  }

  return {};
};

export const normalizeElementsResponse = (
  payload?: RawElementsResponse,
): ElementsQueryData => {
  return {
    elements: (payload?.elements || []).map((element) => ({
      ...element,
      config: parseElementConfig(element.config),
    })),
    requests: payload?.requests || [],
    elementsVersion: Number(payload?.elementsVersion || 0),
  };
};

export const serializeElementsPayload = (elements: Element[]) =>
  elements.map((element) => ({
    ...element,
    config: JSON.stringify(element.config || {}),
  }));
